export default __webpack_public_path__ + "static/media/MLB.d61209e8.jpg";